module.exports = __webpack_public_path__ + "img/shower.9763a60c.svg";